import { getAppConfig } from '@services/config';
import { cmsHttpService } from '@services/http';
import { CACHE_TAGS } from '@services/http/http';

const appConf = getAppConfig();

export async function getEsimSupportedDevices(): Promise<string> {
    const path = `${appConf.assets.partials.url}/mixte/modal_e_sim_mobiles_compatibles`;
    return cmsHttpService.get<string>(path, undefined, {
        ttl: parseInt(getAppConfig().cache.ttl.cms),
        tags: [CACHE_TAGS.CMS],
    });
}
